import { Fragment } from 'react';
import { Link, useParams } from 'react-router-dom';
import PageShell, { PageTitle } from '../components/PageShell';
import CallButton from '../components/CallButton';
import HelpBox from '../components/HelpBox';
import FaqAccordion from '../components/FaqAccordion';
import { ARTICLE_CATEGORIES, articlePath, findArticle, relatedArticles } from '../constants/articles';
import { DISCLAIMER_SHORT } from '../constants/content';
import NotFound from './NotFound';

function Section({ section }) {
  return (
    <section className="entry-section entry-section--left">
      <h2>{section.heading}</h2>
      {section.paragraphs?.map((text) => (
        <p key={text}>{text}</p>
      ))}
      {section.steps ? (
        <ol>
          {section.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      ) : null}
      {section.bullets ? (
        <ul>
          {section.bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}

export default function ArticlePage() {
  const { slug } = useParams();
  const article = findArticle(slug);

  if (!article) return <NotFound />;

  const category = ARTICLE_CATEGORIES.find((cat) => cat.key === article.category);
  const related = relatedArticles(article);

  return (
    <PageShell>
      <article className="article">
        <PageTitle
          title={article.title}
          crumbs={[
            { label: 'Blogs', to: '/blogs' },
            { label: category.label, to: category.hub },
          ]}
        />
        <p className="entry-meta">
          Part of our <Link to={category.hub}>{category.label}</Link> help series
        </p>

        {article.intro.map((text) => (
          <p key={text}>{text}</p>
        ))}

        <CallButton />

        {article.sections.map((section, index) => (
          <Fragment key={section.heading}>
            <Section section={section} />
            {index % 2 === 1 ? <CallButton /> : null}
          </Fragment>
        ))}

        <HelpBox
          title="Didn’t Solve It?"
          text="Every computer is a little different. Call or chat and a technician will work through this with you on your own PC or Mac."
        />

        {article.faqs?.length ? (
          <section className="entry-section">
            <h2>Readers Also Ask</h2>
            <FaqAccordion items={article.faqs} />
          </section>
        ) : null}

        {related.length ? (
          <section className="entry-section entry-section--left">
            <h2>Keep Reading</h2>
            <ul className="link-list">
              {related.map((other) => (
                <li key={other.slug}>
                  <Link to={articlePath(other.slug)}>{other.title}</Link>
                </li>
              ))}
            </ul>
          </section>
        ) : null}

        <CallButton />

        <p className="small-print">{DISCLAIMER_SHORT}</p>
      </article>
    </PageShell>
  );
}
